import React from "react";

export const THEME_BLUE_BG = "bg-[#f8fbff]";
export const BORDER_SMART = "border-gray-300";

export function PageLayout({ children }) {
  return (
    <div
      className={`w-full min-h-[calc(100vh-140px)] ${THEME_BLUE_BG} pb-20`}
    >
      {children}
    </div>
  );
}

export function PageHeader({
  icon: Icon,
  title,
  subtitle,
  right,
}) {
  return (
    <div className={`border-b bg-white px-6 py-6 ${BORDER_SMART}`}>
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="grid h-12 w-12 place-items-center rounded-xl bg-[#01C37D]/10">
            <Icon className="text-[#01C37D]" size={22} />
          </div>

          <div>
            <h1 className="text-xl font-semibold text-gray-900">
              {title}
            </h1>

            <p className="text-sm text-gray-500">
              {subtitle}
            </p>
          </div>
        </div>

        {right}
      </div>
    </div>
  );
}

export function SectionCard({
  title,
  children,
  icon: Icon,
  rightAction,
}) {
  return (
    <div
      className={`rounded-2xl border ${BORDER_SMART} bg-white p-6 shadow-sm`}
    >
      <div className="mb-5 flex items-center justify-between">
        <div className="flex items-center gap-2">
          {Icon && (
            <div className="rounded-lg bg-[#01C37D]/10 p-2">
              <Icon className="text-[#01C37D]" size={18} />
            </div>
          )}

          <div className="text-xs font-bold uppercase tracking-widest text-gray-500">
            {title}
          </div>
        </div>

        {rightAction}
      </div>

      {children}
    </div>
  );
}

export function Input(props) {
  return (
    <input
      {...props}
      className={`h-11 w-full rounded-xl border ${BORDER_SMART}
      bg-white px-3 text-sm outline-none
      focus:border-[#01C37D]
      focus:ring-4
      focus:ring-[#01C37D]/5
      transition-all ${props.className || ""}`}
    />
  );
}

export function Field({ label, children }) {
  return (
    <div>
      <label className="mb-2 block text-[11px] font-bold uppercase tracking-widest text-gray-500">
        {label}
      </label>

      {children}
    </div>
  );
}

export function PrimaryButton({
  children,
  className = "",
  ...props
}) {
  return (
    <button
      {...props}
      className={`flex items-center justify-center gap-2 rounded-xl
      bg-[#01C37D] px-5 py-2.5 text-sm font-semibold
      text-white transition-all hover:bg-[#00ae70]
      active:scale-[0.98] ${className}`}
    >
      {children}
    </button>
  );
}